import { useMutation, gql } from '@zenbusiness/application-commons-graphql';
import { useSearchParams } from 'react-router-dom';

import useVisit from '../../hooks/useVisit';
import { recordException } from '../../utils/reporting';
import {
  UTM_SOURCE, UTM_MEDIUM, UTM_CONTENT, UTM_TERM, UTM_CAMPAIGN, UTM_SOURCE_SFMC, UTM_MEDIUM_EMAIL
} from './constants/campaign';

const CREATE_VISIT = gql`
  mutation CreateVisit($input: CreateVisitInput!) {
    createVisit(input: $input) {
      visitUuid
    }
  }
`;

const generateVisitData = (href, search, referrer) => {
  const queryParams = new URLSearchParams(search);
  return {
    website: href.replace(search, ''),
    referrer: referrer || null,
    landingUrl: href,
    campaignsource: queryParams.get(UTM_SOURCE),
    campaignmedium: queryParams.get(UTM_MEDIUM),
    campaignname: queryParams.get(UTM_CAMPAIGN),
    campaignterm: queryParams.get(UTM_TERM),
    campaigncontent: queryParams.get(UTM_CONTENT),
    gclid: queryParams.get('gclid')
  };
};

const VisitManager = () => {
  const { visit, setVisit } = useVisit();
  const [searchParams] = useSearchParams();

  const hasSourceSfmc = searchParams.get(UTM_SOURCE) === UTM_SOURCE_SFMC;
  const hasMediumEmail = searchParams.get(UTM_MEDIUM) === UTM_MEDIUM_EMAIL;

  const {
    visitProcessed = false
  } = visit;

  const {
    location: {
      href,
      search
    },
    referrer
  } = document;
  const visitData = generateVisitData(href, search, referrer);

  const [createVisit, {
    data: createData,
    loading: createLoading,
    error: createError
  }] = useMutation(CREATE_VISIT, {
    variables: {
      input: {
        ...visitData
      }
    },
    noThrow: true
  });

  const handleVisitUpdate = (update) => {
    setVisit({
      ...visit,
      visitData,
      ...update
    });
  };

  if (
    (!visitProcessed && !createLoading)
    && ((!createData && !createError)
    || (hasSourceSfmc && hasMediumEmail))
  ) {
    createVisit()
      .then(({ data = {} }) => {
        const {
          createVisit: {
            visitUuid = null
          } = {}
        } = data;
        handleVisitUpdate({
          visitUuid,
          visitProcessed: true
        });
      })
      .catch((err) => {
        recordException(err);
        handleVisitUpdate({
          visitUuid: null,
          visitProcessed: true
        });
      });
  }

  return (
    <></>
  );
};

export default VisitManager;
